import checkAccess from 'utils/roles/checkAccess';
import getFranchiseRegion from 'utils/jwt/getFranchiseRegion';

export const routerPath = {
  root: '/gym-attendance-with-red-line',
};

export const getColumns = () => [
  { id: 'facilityName', label: 'Gym', align: 'left', disableSort: true },
  { id: 'region', label: 'Region', align: 'center', disableSort: true },
  { id: 'entriesBudgeted', label: 'Entries Budgeted', align: 'center', disableSort: true },
  { id: 'actualEntries', label: 'Actual Entries', align: 'center' },
  { id: 'uniqueEntries', label: 'Unique Entries', align: 'center', disableSort: true },
  { id: 'redLinePercent', label: 'Red Line %', align: 'center' },
  { id: 'excessEntries', label: 'Excess Entries', align: 'center' },
  { id: 'excessValue', label: 'Excess Value', align: 'center' },
];

export const getFilters = ({ facilityName, region, redLine, options, yearMount }) => [
  {
    id: 'facilityName',
    type: 'select',
    label: 'Facility Name',
    value: facilityName.value,
    action: facilityName.change,
    items: options?.facilityNames?.length ? ['all', ...options.facilityNames] : ['all'],
  },
  {
    id: 'region',
    type: 'select',
    label: 'Region',
    value: checkAccess([2]) ? getFranchiseRegion() : region.value,
    action: region.change,
    items: options?.regions?.length ? ['all', ...options.regions] : ['all'],
    disabledEdit: checkAccess([2]),
  },
  {
    id: 'yearMonth',
    type: 'yearMonth',
    label: 'Year Month',
    value: yearMount.value,
    action: yearMount.change,
  },
  {
    id: 'redLine',
    type: 'switch',
    label: 'Red Line',
    value: redLine.value === 'true',
    action: redLine.change,
  },
];
